<template>
  <div class="signup-risk">
    <div>
      <!-- <div class="smglrxx">
        <div>报名参赛 > 私募管理人信息</div>
      </div> -->
      <div class="bmcs-con">
        <div>
          <div class="title bmcs"></div>
          <div class="goods-name">即将开启，敬请期待</div>

          <!-- <div>
            <div class="goods-name">私募管理人信息</div>
            <div class="tables manager-tables">
              <table cellspacing="0">
                <tr>
                  <th style="width: 280px;height: 52px;">* 公司全称</th>
                  <td style="width: 580px;"><input v-model="institutName"/></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">* 中基协登记编号</th>
                  <td><input v-model="institutRecordNum"/></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">中基协登记证明</th>
                  <td><div class="files"><span v-if="fileName1" class="filename">{{fileName1}}</span><span v-if="!fileName1" class="filename fileholder">(上传jpg、png、pdf、bmp格式且小于1M的文件)</span><div class="inputbutton"><input type="file" accept="image/jpg,image/png,image/bmp,application/pdf" @change="getFile1($event)" ref="file"/><div class="filebutton upload"><img src="../assets/upload.png" />上传</div></div><div class="filebutton delete" @click="deleteFile1($event)"><img src="../assets/delete.png" />删除</div>
                  </div>
                  </td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">* 机构管理规模</th>
                  <td><input class="gm" placeholder="(单位：万元)" v-model="assetSize" @input="assetSize=assetSize.replace(/[^\d^\.]+/g,'')"/><span v-if="assetSize">万元</span></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">营业执照</th>
                  <td><div class="files"><span v-if="fileName2" class="filename">{{fileName2}}</span><span v-if="!fileName2" class="filename fileholder">(上传jpg、png、pdf、bmp格式且小于1M的文件)</span><div class="inputbutton"><input type="file" accept="image/jpg,image/png,image/bmp,application/pdf" @change="getFile2($event)" ref="file"/><div class="filebutton upload"><img src="../assets/upload.png" />上传</div></div><div class="filebutton delete" @click="deleteFile2($event)"><img src="../assets/delete.png" />删除</div>
                  </div>
                  </td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">* 联系人</th>
                  <td><input v-model="linkman"/></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">* 联系人手机</th>
                  <td><input v-model="linkmanMobile" @input="linkmanMobile=linkmanMobile.replace(/[^\d]/g,'')"/></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">联系人座机</th>
                  <td><input v-model="linkmanPhone"/></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">* 联系人邮箱</th>
                  <td><input v-model="linkmanEmail"/></td>
                </tr>
                <tr>
                  <th style="width: 280px;height: 52px;">QQ</th>
                  <td><input v-model="linkmanQQ"/></td>
                </tr>
              </table>
            </div>
            <div>
              <div class="nextstep-con">
                <div class="agreerisk">
                  <input type="checkbox" v-model="hasread" value="1"/> <a
                  @click="showrisknotice=true">我已阅读提示风险，并同意大赛规则</a>
                </div>
                <div class="stepbutton" @click="gonextstep">下一步</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <risknotice v-if="showrisknotice" @closerisknotice="closerisknotice"></risknotice>
  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import format from '../fetch/format'
  import risknotice from './risknotice'

  export default {
    components: {
      risknotice
    },
    data() {
      return {
        closenotice: true,
        institutName: "",
        institutRecordNum: "",
        institutRecordAttach: "",
        assetSize: "",
        institutLicenseAttach: "",
        linkman: "",
        linkmanMobile: "",
        linkmanPhone: "",
        linkmanEmail: "",
        linkmanQQ: "",
        hasread: "",
        goodscount: [{}],
        showrisknotice: false,
        fileName1: "",
        fileName2:""
      }
    },
    mounted() {
      if(this.$store.state.loginState) {
        this.productLength = window.localStorage.productList ? window.localStorage.productList : 0
      } else {
        var temp=format.formatKeys(this.$route.query)
        var params=temp.substring(0,temp.length-1)
        this.$router.push("/?"+params)
        
        // this.$set(this.$store.state,'loginState',false)
        // this.$forceUpdate()
      }
    },
    methods: {

      async getFile1(event) {
        if(event.target.files[0].size>1024000) {
          this.$store.state.noticeMessage='请上传小于1M的文件'
          return
        } else {

          this.fileName1=event.target.files[0].name
          let formData = new FormData();
          formData.append('file', event.target.files[0],event.target.files[0].name);
          var data = await http.upload(formData)
          if(data.code=='0') {
          this.institutRecordAttach = data.data.url
          } else {
            this.fileName1=""
          this.institutRecordAttach = ""
          }
        }
      },
      deleteFile1(event) {
        this.institutRecordAttach = ""
        this.fileName1=""
      },
      async getFile2(event) {
        if(event.target.files[0].size>1024000) {
          this.$store.state.noticeMessage='请上传小于1M的文件'
          return
        } else {
          this.fileName2 = event.target.files[0].name
          let formData = new FormData();
          formData.append('file', event.target.files[0], event.target.files[0].name);
          var data = await http.upload(formData)
          // this.institutLicenseAttach = data.data.url
          if(data.code=='0') {
            this.institutLicenseAttach = data.data.url
          } else {
            this.fileName2=""
          this.institutLicenseAttach = ""
          }
        }
      },
      deleteFile2(event) {
        this.institutLicenseAttach = ""
        this.fileName2=""
      },
      closerisknotice() {
        this.showrisknotice = false
        this.hasread='1'
      },
      async gonextstep() {

        // window.localStorage.institutId = '1000'
        // this.$router.push({"path": "/signup"})
        if(!this.institutName) {
          // format.message("公司全称不能为空","error")
          this.$store.state.noticeMessage="公司全称不能为空"
          return
        }
        if(!this.institutRecordNum) {
          // format.message("中基协登记编号不能为空","error")
          this.$store.state.noticeMessage="中基协登记编号不能为空"
          return
        }
        // if(!this.institutRecordAttach) {
          // format.message("中基协登记证明不能为空","error")
          // this.$store.state.noticeMessage="中基协登记证明不能为空"
          // return
        // }
        if(!this.assetSize) {
          this.$store.state.noticeMessage="机构管理规模不能为空"
          return
        }
        // if(!this.institutLicenseAttach) {
          // format.message("营业执照不能为空","error")
          // this.$store.state.noticeMessage="营业执照不能为空"
          // return
        // }
        if(!this.linkman) {
          // format.message("联系人不能为空","error")
          this.$store.state.noticeMessage="联系人不能为空"
          return
        }
        if(!this.linkmanMobile) {
          // format.message("联系人手机不能为空","error")
          this.$store.state.noticeMessage="联系人手机不能为空"
          return
        }
        if(!this.linkmanEmail) {
          // format.message("联系人邮箱不能为空","error")
          this.$store.state.noticeMessage="联系人邮箱不能为空"
          return
        }
        var telreg = /^1[3456789]\d{9}$/
        if(!telreg.test(this.linkmanMobile)) {
          this.$store.state.noticeMessage="请输入正确格式的联系人手机号"
          return
        }
        var reg=/([a-zA-Z0-9_\.\-]+)@([a-zA-Z0-9_\.\-]+)\.([a-zA-Z]{2,4})$/
        if(!reg.test(this.linkmanEmail)) {
          this.$store.state.noticeMessage="请输入正确格式的邮箱"
          return
        }
        var managerInfo = {
          institutName: this.institutName,
          institutRecordNum:this.institutRecordNum,
          institutRecordAttach: this.institutRecordAttach,
          assetSize:this.assetSize,
          institutLicenseAttach: this.institutLicenseAttach,
          linkman: this.linkman,
          linkmanMobile: this.linkmanMobile,
          linkmanPhone: this.linkmanPhone,
          linkmanEmail: this.linkmanEmail,
          linkmanQQ:this.linkmanQQ
        }
        if(this.hasread!='1') {
          this.$store.state.noticeMessage="您未同意大赛规则"
          return
        }
        var data = await http.institut(managerInfo)
        if(data.code=='0') {
          window.localStorage.productList = 0 //填写私募管理人信息 参赛产品数量一定是0
          window.localStorage.institutId = '1000'
          var temp=format.formatKeys(this.$route.query)
          var params=temp.substring(0,temp.length-1)
          this.$router.push("/signup?"+params)
        }
      }
    }
  }
</script>
<style scoped>
  .smglrxx, .cscpxx {
    height: 60px;
    line-height: 60px;
    background: #f4f7f9;
  }

  .smglrxx div, .cscpxx div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -ms-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;

  }

  .bmcs-con > div {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
  }

  .bmcs {
    background-image: url("../assets/bmcs.png");
  }

  .goods-name {
    text-align: center;
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 32px;
    letter-spacing: 1px;
    color: #007fcf;
    margin-top: 50px;
  }

  .tables {
    margin: 20px auto 0 auto;
    padding: 6px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
  }

  .close {
    position: absolute;
    right: 10px;
    top: -25px;
  }

  .manager-tables {
    width: 880px;
    height: 530px;
    background-image: url("../assets/smglr.png");
  }

  .manager-tables td input {
    width: 580px;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0;
    border: none;
    height: 52px;
    background: none;
    outline: none;

  }

  .goods-tables {
    width: 977px;
    height: 587px;
    background-image: url("../assets/cscpxx.png");
  }

  table input {
    margin: 0 5px 0 10px;
  }

  table th {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .m-center {
    margin: 30px auto;
    text-align: center;
  }

  .add-goods {
    color: #27a7ea;
    text-decoration: underline;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
  }

  .max-e {
    color: #b5b5b5;
    text-decoration: underline;
    height: 30px;
    line-height: 30px;
  }

  .suresignup {
    width: 400px;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
    background: #b5b5b5;
    color: #fff;
    margin: 20px auto;
  }

  .risknotice {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .notice-content {
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-image: url("../assets/fxgz.png");
    width: 1020px;
    height: 735px;
  }

  .notice-title {
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    height: 28px;
    letter-spacing: 1px;
    margin: 10px 0;
    color: #27a7ea;
  }

  .whitediv {
    height: 60px;
  }

  .noticetext {

    font-size: 16px;
    margin: 0px 70px 30px 70px;
    text-align: left;
    height: 550px;
    overflow: scroll;
  }

  .noticetext p {
    line-height: 28px;
    letter-spacing: 1px;
  }

  /*滚动条整体样式*/
  .noticetext::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .noticetext::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .noticetext::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .agree {
    text-align: center;
    width: 240px;
    background: #00bcbc;
    margin: 0 auto;
    color: #fff;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
  }

  .table {
    width: 500px;
    margin: 20px auto;
    text-align: center;
    border-left: solid 1px #232323;
    border-top: solid 1px #232323;
  }

  .table th, .table td {
    border-right: solid 1px #232323;
    border-bottom: solid 1px #232323;
  }

  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -25px;
  }

  .nextstep-con {
    text-align: center;
    margin-top: 30px;
  }

  .agreerisk {
    color: #27a7ea;
  }

  .agreerisk a {
    text-decoration: underline;
  }

  .stepbutton {
    width: 400px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    background: #27a7ea;
    border-radius: 6px;
    margin-top: 30px;
    color: #fff;
  }

  .goods-tables .fullinput {
    width: 565px;
    height: 52px;
    outline: none;
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
  }

  .goods-tables .moreinput, .goods-tables .lessinput {
    height: 48px;
    outline: none;
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
  }

  .goods-tables .moreinput {
    width: 60px;
  }

  .goods-tables .lessinput {
    width: 45px;
  }

  .emailinput {
    width: 290px;
    height: 50px;
    margin: 0;
    padding: 0 10px;
    border: none;
    box-sizing: border-box;
    outline: none;

  }

  .files {
    position: relative;
  }
  .inputbutton {
    position: absolute;
    display: inline-block;
    width: 90px;
    height: 48px;
    line-height: 48px;
    right: 110px;
  }
  .filename {
    width: 380px;
    height:40px;
    line-height: 40px;
    border: none;
    outline: none;
    display: inline-block;
    padding-left: 10px;
  }
  .fileholder {
    color: #cacaca;
    font-size: 16px;
  }

    input::-webkit-input-placeholder{
      color:#cacaca;
      font-size: 16px;
    }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#cacaca;
    font-size: 16px;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#cacaca;
    font-size: 16px;
  }
  input:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #cacaca;
    font-size: 16px;
  }
  .manager-tables td input[type='file'] {
    opacity: 0;
    width: 90px;
    height: 40px;
    position: absolute;
    right: 0;
    top: 0;
    margin:0;
  }
  .filebutton {
    display: inline-block;
    width: 90px;
    border: solid 1px;
    text-align: center;
    border-radius: 6px;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;

  }
  .filebutton img {
    width: 22px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .upload {
    pointer-events: none;
    border-color: #007fcf;
    color: #007fcf;
    position: absolute;
    right: 0;
    top: -1px;
  }
  .delete {
    border-color: #f53f3f;
    color: #f53f3f;
    position: absolute;
    right: 10px;
    top: -1px;
  }
  .manager-tables td input.gm {
    width: 130px;
  }
</style>



// WEBPACK FOOTER //
// src/components/manager.vue